import React from 'react'
import style from './card.module.css'

function Shwetha() {
  return (
    <div className = {style.sumit}>
        <img src='https://edge.uacdn.net/static/thumbnail/user/0c703291245b45c7bc51efd99ff688a4.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img'/>
        <div>
            <h1>Shweta Batra</h1> 
              <p>I am M.Sc Chemistry (Gold Medalist)
                  have been mentoring class 11th 12th and NDA
                  Students from past long years
            </p> 
            <p>Teaches UPSC NDA and 8 more</p>  
        </div> 
    </div>
  )
}

export default Shwetha;